import type { FC, ReactNode } from 'react'

const words = [
    "Ginger threads",
    "Scallions",
    "Crispy shallots",
    "Soft egg",
    "Sesame oil",
    "White pepper",
    "Fried dough",
    "Chili crisp",
    "Cilantro"
]

const MarqueeRow: FC<{ hidden?: boolean }> = ({ hidden = false }): ReactNode => {
    return (
        <ul aria-hidden={hidden || undefined} className='flex shrink-0 items-center'>
            {words.map(word => (
                <li key={word} className='flex items-center'>
                    <span className='px-6 font-heading text-2xl italic sm:text-3xl'>
                        {word}
                    </span>

                    <span aria-hidden='true' className='size-2 rotate-45 rounded-[2px] bg-yolk' />
                </li>
            ))}
        </ul>
    )
}

export const ToppingsMarquee: FC = (): ReactNode => {
    return (
        <section aria-label="Toppings we finish our bowls with" className='overflow-hidden bg-broth py-5 text-broth-foreground'>
            <div className='flex w-max animate-marquee'>
                <MarqueeRow />
                <MarqueeRow hidden />
            </div>
        </section>
    )
}
